import BigNumber from 'bignumber.js'
import { getDefaultToken } from '.'

type SeesawProps = {
  raw: string
  startPiece?: number
  endPiece?: number
  splitStr?: string
  isHash?: boolean
  isAddress?: boolean
}
export function seesaw({ raw, startPiece = 3, endPiece = 3, splitStr = ':', isHash, isAddress }: SeesawProps) {
  if (raw.length <= startPiece + endPiece) {
    return raw
  }
  const hash = raw.split(splitStr)[0]
  const content = hash.slice(0, startPiece) + ':' + hash.slice(endPiece * -1)
  if (isHash) return `<${content}>`
  if (isAddress) return `[${content}]`
  return content
}

export const prettyNumber = (value: number | string) => {
  if (!new RegExp(/^[\d]{1,}$/).test(value.toString())) return value
  if (typeof value === 'string') {
    const [int, float] = value.split('.')
    let result = ''
    let count = 0
    for (let i = int.length - 1; i > -1; i--) {
      count++
      result = int.substr(i, 1) + result
      if (count === 3 && i !== 0) {
        result = ',' + result
        count = 0
      }
    }
    return result + (float ? '.' + float : '')
  }
  return value.toLocaleString()
}

type ToDioProps = {
  value?: string | number
  withUnit?: boolean
  fixed?: number
  isPretty?: boolean
}
export function toDio({ value, withUnit, fixed, isPretty }: ToDioProps): string {
  const defaultToken = getDefaultToken()
  if (!value && value !== 0) return ''
  if (!value) return '0' + (withUnit ? ` ${defaultToken.SYMBOL}` : '')
  if (typeof value === 'string') {
    value = value.split(':')[0]
  }
  if (typeof fixed === 'number') {
    value = new BigNumber(value).dividedBy(10 ** defaultToken.DECIMAL).toFixed(fixed, 1)
  } else {
    value = new BigNumber(value).dividedBy(10 ** defaultToken.DECIMAL).toFixed()
  }
  value = value.replace(/(\.[0-9]*[1-9])0*|(\.0*)/, '$1')
  if (isPretty) {
    const [int, float] = value.split('.')
    value = prettyNumber(int) + (float ? '.' + float : '')
  }
  return value + (withUnit ? ` ${defaultToken.SYMBOL}` : '')
}

export function toToken(props: {
  value?: string | number
  decimals?: number
  flags?: number
  symbol?: string
  isPretty?: boolean
}): string {
  const { value, symbol, flags, isPretty } = props
  const decimals = flags ? toDecimals(flags) : props?.decimals
  if (!value && value !== 0) return ''
  let tokenValue = value
  if (typeof tokenValue === 'string') {
    tokenValue = tokenValue.split(':')[0]
  }
  if (typeof decimals === 'number') {
    tokenValue = new BigNumber(value).dividedBy(10 ** decimals).toFixed(decimals, 1)
  } else {
    tokenValue = new BigNumber(value).dividedBy(10 ** 0).toFixed()
  }

  tokenValue = tokenValue.replace(/(\.[0-9]*[1-9])0*|(\.0*)/, '$1')
  if (isPretty) {
    const [int, float] = tokenValue.split('.')
    tokenValue = prettyNumber(int) + (float ? '.' + float : '')
  }
  return tokenValue + (symbol ? ` ${symbol}` : '')
}

export const toDecimals = (flags?: number | string): number => {
  if (flags === undefined) return 0
  const n = Number(flags) >> 22
  return parseInt(n.toString(2).substr(-6), 2)
}
// 乘
export const bignumberMult = (val1: number | string, val2: number | string) => {
  return new BigNumber(val1).multipliedBy(val2).toFixed()
}
// 除
export const bignumberDivided = (val1: number | string, val2: number | string) => {
  return new BigNumber(val1).dividedBy(val2).toFixed()
}
// 减
export const bignumberMinus = (val1: number | string, val2: number | string) => {
  return new BigNumber(val1).minus(new BigNumber(val2))
}
// 加
export const bignumberPlus = (val1: number | string, val2: number | string) => {
  return new BigNumber(val1).plus(new BigNumber(val2))
}

export const toNFTID = (serie: string | number, id?: string | number, count?: number) => {
  if (!id) return ''
  const bigNumberID = new BigNumber(id)
  if (count && count > 1) {
    return `#${serie} [${bigNumberID.toString(16)}] - #${count - 1 + Number(serie)} [${bigNumberID
      .plus(count - 1)
      .toString(16)}]`
  }
  return `#${serie} [${bigNumberID.toString(16)}]`
}
